module.exports = __webpack_public_path__ + "img/material_scan_act.a4900fa4.png";